import {NgModule} from '@angular/core';
import {FilterChipComponent} from './filter-chip.component';
import {SharedModule} from '../shared.module';

export const MODULE_DECLARATIONS = [FilterChipComponent];

export const MODULE_IMPORTS = [SharedModule];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: [FilterChipComponent],
})
export class FilterChipModule {}
